exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".box-card[data-v-3585a720]{margin-bottom:20px;width:500px}.box-item[data-v-3585a720]{line-height:30px}", ""]);

// exports
